import(/* webpackMode: "eager" */ "/app/app/auth/decide/page.tsx");
